import { drawImage } from 'canvas-object-fit';

export const UPLOAD_PREVIEW_SIZE = 400;

export const UPLOAD_PREVIEW_LOAD_TIMEOUT_MS = 30_000;

export type LoadUploadPreviewParams = {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  objectUrl: string;
  onError: () => void;
  onPreview: (imageBase64: string) => void;
};

export const loadUploadImagePreview = ({ canvas, ctx, objectUrl, onError, onPreview }: LoadUploadPreviewParams) => {
  const image = document.createElement('img');
  let settled = false;
  let loadTimeoutId = 0;

  const settle = (callback: () => void) => {
    if (settled) {
      return;
    }

    settled = true;
    window.clearTimeout(loadTimeoutId);
    callback();
  };

  loadTimeoutId = window.setTimeout(() => {
    settle(onError);
  }, UPLOAD_PREVIEW_LOAD_TIMEOUT_MS);

  image.onload = () => {
    settle(() => {
      try {
        canvas.width = UPLOAD_PREVIEW_SIZE;
        canvas.height = UPLOAD_PREVIEW_SIZE;
        drawImage(ctx, image, 0, 0, UPLOAD_PREVIEW_SIZE, UPLOAD_PREVIEW_SIZE, { objectFit: 'cover' });
        onPreview(canvas.toDataURL());
      } catch {
        onError();
      }
    });
  };

  image.onerror = () => {
    settle(onError);
  };

  image.src = objectUrl;

  return () => {
    settled = true;
    window.clearTimeout(loadTimeoutId);
    image.onload = null;
    image.onerror = null;
    image.src = '';
  };
};
